// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".img-wrapper__inner[data-v-312844a9]{display:none}.slider[data-v-312844a9]{height:68px;padding:24px 32px;display:flex;align-items:center}.slider__control[data-v-312844a9]{cursor:pointer;font-size:16px;color:#193154}.slider__control[data-v-312844a9]:first-of-type{margin-right:12px}.slider__control[data-v-312844a9]:nth-of-type(2){margin-left:12px}.slider__inner[data-v-312844a9]{flex-grow:1}", ""]);
// Exports
module.exports = exports;
